import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '../../components/Alert/Alert';
import BackButton from '../../components/BackButton';
import NoSlotForm from '../../components/NoSlots/NoSlotForm';
import { MAX_SLOTS_TO_SHOW } from '../../components/NoSlots/NoSlotsConstants';
import { NoTopSlot } from '../../interfaces/NoTopSlot';
import { Stylesheet } from '../../interfaces/Stylesheet';
import { Ticket } from '../../interfaces/Ticket';
import { useFormatting } from '../../services/hooks/useFormatting';
import styles from './Appointment.module.scss';

interface AppointmentWithoutTopSlotsProps {
  lowAvailabilityAlert?: React.ReactNode;
  noTopSLots: NoTopSlot[];
  refetchNoTopSlots: () => void;
  stylesheet: Stylesheet;
  ticket: Ticket;
}

const AppointmentWithoutTopSlots: FC<AppointmentWithoutTopSlotsProps> = ({
  noTopSLots, ticket, stylesheet, lowAvailabilityAlert, refetchNoTopSlots
}) => {
  const {
    appointmentSection: { noSlotsBlock }
  } = stylesheet;
  const { formattedText: noSlotsText } = useFormatting(noSlotsBlock.value);

  const { t } = useTranslation();

  const hasNoTopSlots: boolean = !!noTopSLots.length;

  const showScrollingAlert = noTopSLots.length > MAX_SLOTS_TO_SHOW;

  return (
    <>
      <div className={styles.content}>
        <BackButton text={t('appointment:goBack')} />
      </div>
      <h1 className={styles.h1}>{t('appointment:title')}</h1>
      <div className={styles.content}>
        <p dangerouslySetInnerHTML={{ __html: noSlotsText }} role="note" />
      </div>
      {lowAvailabilityAlert}

      {(showScrollingAlert || !hasNoTopSlots) && (
        <Alert
          level={!hasNoTopSlots ? 'error' : 'info'}
          text={!hasNoTopSlots ? t('noslots:alertError') : t('noslots:alertInfo')}
          textButton={!hasNoTopSlots ? { text: t('noslots:alertButton'), onClick: refetchNoTopSlots } : undefined}
          white
        />
      )}
      {hasNoTopSlots && (
        <div className={styles.noSlots}>
          <NoSlotForm
            hashId={ticket.hashId}
            noTopSlots={noTopSLots}
            workorderId={ticket.workOrder.id}
          />
        </div>
      )}
    </>
  );
};

export default AppointmentWithoutTopSlots;
